import { themeGet, pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  grid-gap: ${themeGet('spacing.2xl')};
  min-height: 100vh;
  padding: ${themeGet('spacing.xl')};
  margin: 0 auto;
`;
export const Line = styled.hr `
  margin-left: inherit;
  width: ${pxToRem(125)};
  border-color: ${themeGet('colors.gray.100')};
  margin-bottom: ${themeGet('spacing.lg')};
`;
export const Image = styled.img `
  display: block;
  max-width: 100%;
`;
